import controlDate from './index.js';

const SET_DELIVERY_TYPES = (state, fetchedDeliveryTypes) => {
  state.deliveryTypes = fetchedDeliveryTypes;
  state.deliveryTypes_outdated=false;
};

const INVALIDATE_DELIVERY_TYPE_LIST = (state) =>{
  state.deliveryTypes_outdated = true
}

const SET_LOCATIONS = (state, locations)=>{
  state.locations = locations;
  state.locations_outdated = false;
}

const INVALIDATE_LOCATION_LIST = (state)=>{
  state.locations_outdated = true
}

const SET_PAYMENT_METHODS = (state, paymentMethods)=>{
  state.paymentMethods = paymentMethods;
  state.paymentMethods_outdated = false;
}

const INVALIDATE_PAYMENT_METHODS = (state)=>{
  state.paymentMethods_outdated = true;
}

const SET_PAYMENT_TYPE_CATEGORIES = (state, paymentTypeCategories)=>{
  state.paymentTypeCategories = paymentTypeCategories;
  state.paymentTypeCategories_outdated = false;
}

const INVALIDATE_PAYMENT_TYPE_CATEGORIES = (state)=>{
  state.paymentTypeCategories_outdated = true;
}

const SET_COMPANY_ROLES = (state, companyRoles) => {
  state.companyRoles = companyRoles;
  state.companyRoles_outDated=false;
}

const INVALIDATE_COMPANY_ROLES = (state)=>{
  state.companyRoles_outDated = true;
}

const SET_LIST_VALUES = (state, listValues) =>{
  state.customerClasses = listValues.customer_classes;

  state.currencies = listValues.currencies;
  state.languages = listValues.languages;
  state.customerClasses_outdated=false;
  state.customerTags_outdated=false;
  state.currencies_outdated = false;
  state.languages_outdated = false;
}

const SET_CUSTOMER_TAGS = (state, customerTags) =>{
  state.customerTags = customerTags;
}

const INVALIDATE_CUSTOMER_CLASSES = (state) => {
  state.customerClasses_outdated = true;
}

const INVALIDATE_CUSTOMER_TAGS = (state) => {
  state.customerTags_outdated = true;
}

const INVALIDATE_CURRENCIES = (state) => {
  state.currencies_outdated = true;
}

const INVALIDATE_LANGUAGES = (state) => {
  state.languages_outdated = true;
}


const SET_CUSTOMER_CUSTOM_FIELDS_DEFINITION = (state, customerCustomFieldsDefinition) => {
  state.customerCustomFieldDefinition = customerCustomFieldsDefinition;
  state.customerCustomFieldDefinition_outdated=false;
}

const INVALIDATE_CUSTOMER_CUSTOM_FIELDS_DEFINITION = (state) => {
  state.customerCustomFieldDefinition_outdated=true;
}

const SET_DELIVERY_SCHEDULE_EXCEPTIONS = (state, deliveryScheduleExceptions) => {
  state.deliveryScheduleExceptions = deliveryScheduleExceptions;
  state.deliveryScheduleExceptions_outdated=false;
}

const INVALIDATE_DELIVERY_SCHEDULE_EXCEPTIONS = (state) => {
  state.deliveryScheduleExceptions_outdated=true;
}

const SET_CUSTOM_FIELDS_DEFINITION = (state, customFieldsDefinition)=>{
  state.purchaseOrderLinesCustomFieldsDefinition = customFieldsDefinition;
  state.purchaseOrderLinesCustomFieldsDefinitionInitialized = true;
}

const SET_CUSTOM_FIELDS_DEFINITION_INITIALIZED = (state, purchaseOrderLinesCustomFieldsDefinitionInitialized) => {
  state.purchaseOrderLinesCustomFieldsDefinitionInitialized = purchaseOrderLinesCustomFieldsDefinitionInitialized;
}

const SET_GL_ACCOUNTS = (state, gl_accounts)=>{
  state.gl_accounts = gl_accounts;
  state.gl_accounts_outdated=false;
}

const INVALIDATE_GL_ACCOUNTS = (state) => {
  state.gl_accounts_outdated=true;
}

const SET_TAXES = (state, taxes)=>{
  state.taxes = taxes;
  state.taxes_outdated=false;
}

const INVALIDATE_TAXES = (state) => {
  state.taxes_outdated=true;
}

const SET_CREDIT_NOTE_TYPES = (state, creditNoteTypes) => {
  state.credit_note_types = creditNoteTypes;
  state.credit_note_types_outdated=false;
}

const INVALIDATE_CREDIT_NOTE_TYPES = (state) => {
  state.credit_note_types_outdated=true;
}

const SET_TERRITORIES = (state, territories) => {
  state.territories = territories;
}

const INVALIDATE_TERRITORIES = (state) =>{
  state.territories_outdated = false;
}

const SET_REBATE_TYPES = (state, rebateTypes) => {
  state.rebate_types = rebateTypes;
  state.rebate_types_outdated=false;
}

const INVALIDATE_REBATE_TYPES = (state) => {
  state.rebate_types_outdated=true;
}

const SET_COUNTRIES = (state, countries) => {
  state.countries =countries
  state.countries_outdated = false;
}

const SET_CMS_CONFIGURATION = (state, cmsConfiguration) => {
  state.cmsConfiguration = cmsConfiguration
}

const SET_MULTI_AGENCY_CONFIGURATION = (state, multiAgencyConfiguration) => {
  state.multiAgencyConfiguration = multiAgencyConfiguration
}

const SET_EMAIL_CUSTOM_CONTENT = (state, emailCustomContent) => {
  state.emailCustomContentData = emailCustomContent;
  state.emailCustomContentOutdated=false;
}

const INVALIDATE_EMAIL_CUSTOM_CONTENT = (state) => {
  state.emailCustomContentOutdated=true;
}

const SET_BLOG_TYPES = (state, blogTypes) => {
  state.blogTypes = blogTypes;
}

const SET_INVENTORIES = (state, inventories) => {
  state.inventories = inventories;
}

const INVALIDATE_INVENTORIES = (state ) => {
  state.inventoriesOutdated = true;
}

const SET_PORTAUS_COMPANIES = (state, portausCompanies) => {
  state.portausCompanies = portausCompanies;
  state.portausCompaniesOutdated = false;
}

export default {
  SET_PORTAUS_COMPANIES,
  INVALIDATE_INVENTORIES,
  SET_INVENTORIES,
  SET_EMAIL_CUSTOM_CONTENT,
  INVALIDATE_EMAIL_CUSTOM_CONTENT,
  SET_COUNTRIES,
  SET_DELIVERY_TYPES,
  INVALIDATE_DELIVERY_TYPE_LIST,
  SET_LOCATIONS,
  INVALIDATE_LOCATION_LIST,
  SET_PAYMENT_METHODS,
  INVALIDATE_PAYMENT_METHODS,
  SET_COMPANY_ROLES,
  INVALIDATE_COMPANY_ROLES,
  SET_LIST_VALUES,
  INVALIDATE_CUSTOMER_CLASSES,
  INVALIDATE_CUSTOMER_TAGS,
  INVALIDATE_CURRENCIES,
  INVALIDATE_LANGUAGES,
  SET_CUSTOMER_CUSTOM_FIELDS_DEFINITION,
  INVALIDATE_CUSTOMER_CUSTOM_FIELDS_DEFINITION,
  SET_DELIVERY_SCHEDULE_EXCEPTIONS,
  INVALIDATE_DELIVERY_SCHEDULE_EXCEPTIONS,
  SET_CUSTOM_FIELDS_DEFINITION,
  SET_GL_ACCOUNTS,
  INVALIDATE_GL_ACCOUNTS,
  SET_TAXES,
  INVALIDATE_TAXES,
  SET_CREDIT_NOTE_TYPES,
  INVALIDATE_CREDIT_NOTE_TYPES,
  SET_TERRITORIES,
  INVALIDATE_TERRITORIES,
  SET_PAYMENT_TYPE_CATEGORIES,
  INVALIDATE_PAYMENT_TYPE_CATEGORIES,
  INVALIDATE_REBATE_TYPES,
  SET_REBATE_TYPES,
  SET_CUSTOMER_TAGS,
  SET_CMS_CONFIGURATION,
  SET_CUSTOM_FIELDS_DEFINITION_INITIALIZED,
  SET_BLOG_TYPES,
  SET_MULTI_AGENCY_CONFIGURATION,
};
